import {
  getCountryCodeFromFlagEmoji,
  getFlagImageUrl,
  isFlagEmoji,
} from "./flagEmojiUtils";

interface EmojiPickerButtonProps {
  emoji: string;
  onSelect: (emoji: string) => void;
}

function EmojiPickerButton({ emoji, onSelect }: EmojiPickerButtonProps) {
  const flagImageUrl = getFlagImageUrl(emoji);
  const countryCode = getCountryCodeFromFlagEmoji(emoji);
  const ariaLabel = isFlagEmoji(emoji)
    ? `Insert ${countryCode?.toUpperCase() ?? "country"} flag`
    : `Insert ${emoji}`;

  return (
    <button
      type="button"
      className="flex h-9 w-9 items-center justify-center rounded text-xl hover:bg-gray-100"
      onClick={() => onSelect(emoji)}
      aria-label={ariaLabel}
      title={isFlagEmoji(emoji) ? countryCode?.toUpperCase() : emoji}
    >
      {flagImageUrl ? (
        <img
          src={flagImageUrl}
          alt={`${countryCode?.toUpperCase() ?? "Country"} flag`}
          className="h-6 w-8 rounded-sm border border-gray-200 object-cover"
          loading="lazy"
        />
      ) : (
        emoji
      )}
    </button>
  );
}

export default EmojiPickerButton;
